/**
 * @generated SignedSource<<a817c3302678ec4a9160810759f1be7b>>
 * @relayHash 8d68e14a6afbdd82abfc9672d194bb80
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 498dae0ebf86c266b5be67ef9c38a4f8450961212ce4efc85c614e2fd5154790

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type inheritancePopupQuery$variables = {
  issueId: string;
};
export type inheritancePopupQuery$data = {
  readonly jira: {
    readonly getProjectLinkInheritanceSources: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"inheritancePopup_issueFieldAtlasProjectCommon_InheritancePopupContent">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type inheritancePopupQuery = {
  response: inheritancePopupQuery$data;
  variables: inheritancePopupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "issueId",
    "variableName": "issueId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "inheritancePopupQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueTownsquareProjectLink",
            "kind": "LinkedField",
            "name": "getProjectLinkInheritanceSources",
            "plural": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "inheritancePopup_issueFieldAtlasProjectCommon_InheritancePopupContent"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "inheritancePopupQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueTownsquareProjectLink",
            "kind": "LinkedField",
            "name": "getProjectLinkInheritanceSources",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraTownsquareProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "hasPermission"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "privateProject"
                  }
                ]
              },
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "summary"
                  },
                  {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "xsmall"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      (v2/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "webUrl"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "498dae0ebf86c266b5be67ef9c38a4f8450961212ce4efc85c614e2fd5154790",
    "metadata": {},
    "name": "inheritancePopupQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "600dd4544a21bd6cf3876c430837d737";

export default node;
